import type { IconName } from "@similarweb/icons";
import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import AIAgentTrackingService from "app/pages/sales-intelligence/modules/ai-agent/services/tracking/trackingService";
import {
    StyledArrowRight,
    StyledIconContainer,
    StyledLinkWidget,
} from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/super-agent/components/LinkWidget/styles";

export type LinkWidgetProps = {
    title: string;
    subTitle: string;
    url: string;
    iconName: IconName;
};

export const LinkWidget = ({ title, subTitle, url, iconName }: LinkWidgetProps) => {
    const handleClick = () => {
        AIAgentTrackingService.superAgent.trackLinkClick(url, "link widget");
    };

    return (
        <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            onMouseDown={handleClick}
            data-automation="super-agent-link-widget"
        >
            <StyledLinkWidget>
                <StyledIconContainer>
                    <SWReactIcons
                        iconName={iconName}
                        size="16px"
                    />
                </StyledIconContainer>
                <Stack gap="4px">
                    <Text
                        fontVariant="button"
                        color={colorsPalettes.carbon[500]}
                    >
                        {title}
                    </Text>
                    <Text
                        fontVariant="listItem3"
                        color={colorsPalettes.carbon[300]}
                        whiteSpace="nowrap"
                    >
                        {subTitle}
                    </Text>
                </Stack>
                <StyledArrowRight
                    size={24}
                    color={colorsPalettes.blue[400]}
                />
            </StyledLinkWidget>
        </a>
    );
};
